module.exports = __webpack_public_path__ + "img/client1.f6202191.png";